import * as React from 'react';
import { Map } from 'scenes/map/map';

export interface IMobileUiMapProps {
    centerFromUrl: string;
    zoomFromUrl: string;
    layersFromUrl: string;
}

export interface IMobileUiMapState {}

class MobileUiMapComponent extends React.Component<IMobileUiMapProps, IMobileUiMapState> {
    constructor(props: IMobileUiMapProps) {
        super(props);
    }

    render() {
        let {
            centerFromUrl,
            zoomFromUrl,
            layersFromUrl
        } = this.props;
        return (
            <Map
                centerFromUrl={centerFromUrl}
                zoomFromUrl={zoomFromUrl}
                layersFromUrl={layersFromUrl}
            />
        );
    }
}

export const MobileUiMap = MobileUiMapComponent;
